module.exports = __webpack_public_path__ + "img/k3p_float_ico_half.3a77d948.png";